import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "blockquote-slider",
  "aria-live": "polite"
}
const _hoisted_2 = ["id", "slide-order"]
const _hoisted_3 = { class: "blockquote-slider__text" }
const _hoisted_4 = { class: "blockquote-people" }
const _hoisted_5 = { class: "blockquote-people-slider__mobile-controls" }
const _hoisted_6 = ["slide-order", "aria-controls", "aria-label"]
const _hoisted_7 = { class: "blockquote-people-slider" }
const _hoisted_8 = ["id", "slide-order"]
const _hoisted_9 = ["id", "aria-controls", "aria-label", "slide-order"]
const _hoisted_10 = {
  class: "blockquote-people-slider__box",
  "aria-hidden": "true"
}
const _hoisted_11 = { class: "blockquote-people-slider__img-box" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "blockquote-people-slider__author" }
const _hoisted_14 = { class: "blockquote-people-slider__name" }
const _hoisted_15 = {
  key: 0,
  class: "blockquote-people-slider__subtitle"
}

import { computed } from 'vue'

import { TestimonialRecord, DATA } from '@/pages-site-v2/helpers/testimonials'


export default /*@__PURE__*/_defineComponent({
  __name: 'Blockquotes',
  props: {
    content: {}
  },
  setup(__props: any) {

const props = __props

const items = computed(() => {
  return DATA[props.content]
})

function getButtonID(authorName: string): string {
  const firstName = authorName.split(' ')[0].toLowerCase()
  return `review_${firstName}`
}

function itemImage(item: TestimonialRecord): string {
  // See https://stackoverflow.com/q/40491506/4612064
  // The 'require' here allows to use dynamic image path
  return require(`@/assets.v2/images/${item.image}`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["blockquote", {
      'blockquote--partners': __props.content === 'partners',
      container: __props.content === 'partners',
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          id: `slide-${index}`,
          key: item.author,
          class: _normalizeClass(["blockquote-slider__item", index === 0 ? 'active' : '']),
          "slide-order": index
        }, [
          _createElementVNode("blockquote", _hoisted_3, _toDisplayString(item.text), 1)
        ], 10, _hoisted_2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
          return (_openBlock(), _createElementBlock("button", {
            key: item.author,
            class: _normalizeClass(["blockquote-people-slider__mobile-button", index === 0 ? 'active' : '']),
            "slide-order": index,
            "aria-controls": `slide-${index}`,
            "aria-label": item.author
          }, null, 10, _hoisted_6))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            id: `control-${index}`,
            key: item.author,
            class: _normalizeClass(["blockquote-people-slider__item", index === 0 ? 'active' : '']),
            "slide-order": index
          }, [
            _createElementVNode("button", {
              id: getButtonID(item.author),
              class: "blockquote-people-slider__button",
              "aria-controls": `slide-${index}`,
              "aria-label": item.author,
              "slide-order": index
            }, null, 8, _hoisted_9),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("img", {
                  class: "blockquote-people-slider__img",
                  src: itemImage(item),
                  alt: ""
                }, null, 8, _hoisted_12)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, _toDisplayString(item.author), 1),
                (item.subtitle)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(item.subtitle), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 10, _hoisted_8))
        }), 128))
      ])
    ])
  ], 2))
}
}

})